module.exports = __webpack_public_path__ + "img/saum_lichtblau_ral5012.4aa03668.jpg";